import React from 'react';

const Product = (props) => {
    return (
        <li className="w-full mb-8 md:w-1/3 md:mb-0 md:px-4 text-center">
            <div>
                <a
                    href={props.product.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className="relative pt-full">
                        <img
                            alt={props.product.image.alt}
                            src={props.product.image.src}
                            className="absolute inset-0 w-full h-full block mx-auto object-cover"
                        />
                    </div>
                    <div className="px-6 pt-6 mb-2 font-display font-semibold text-green text-sm leading-tight uppercase">
                        {props.product.name}
                    </div>
                    <dl>
                        <dt>
                            <span className="sr-only">Regular Price</span>
                        </dt>
                        <dd>
                            <span className="block leading-tight text-green text-sm">
                                from {props.product.price}
                            </span>
                        </dd>
                    </dl>
                </a>
            </div>
        </li>
    );
};

export default Product;
